import { Brand } from '@awazevr/design-system.components.awaze-theme-provider'

import { buildPublicAssetUrl } from '@/utils/helpers'

export const MapPin = (brand: Brand, assetPrefix?: string): string => {
  const brandAdjusted = brand === 'cottages.com' ? 'cottages' : brand

  return buildPublicAssetUrl(
    `/map-pins/brand-${brandAdjusted}--pin-not-active@2x.png`,
    assetPrefix,
  )
}
